var _defs, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "circle_svg__a",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "currentColor",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "currentColor",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#circle_svg__a)"
  })));
};
export { SvgCircle as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cdefs%3e %3cradialGradient id='circleGlow' cx='50%25' cy='50%25' r='50%25'%3e %3cstop offset='0%25' stop-color='%234A6067' stop-opacity='0.9'/%3e %3cstop offset='55%25' stop-color='%234A6067' stop-opacity='0.5'/%3e %3cstop offset='100%25' stop-color='%234A6067' stop-opacity='0'/%3e %3c/radialGradient%3e %3c/defs%3e %3ccircle cx='16' cy='16' r='16' fill='url(%23circleGlow)'/%3e %3c/svg%3e";